import * as React from 'react';
import '../css/products.css'
class ProductList extends React.Component<any, any>{
    constructor(props: any) {
        super(props)
        this.state = {
            products: [
                {
                    nome: 'Health Track',
                    descricao: 'Plataforma de gestão com foco em controle de sinistralidade e integração do cuidado',
                    img: require('../css/img/background-healthtrack.jpg'),
                    logo: require('../css/img/logo-healthtrack.png'),
                    url: ''
                },
                {
                    nome: 'TagFit',
                    descricao: 'Programas digitais para prevenção e tratamento de doenças crônicas através de coaching de saúde',
                    img: require('../css/img/background-tagfit.jpg'),
                    logo: require('../css/img/logo-tagfit.png'),
                    url: 'http://www.tagfit.com.br/'
                },
                {
                    nome: 'Zero Cigarro',
                    descricao: 'Programa digital de combate ao tabagismo, baseado em mensagens e atendimento online',
                    img: require('../css/img/background-zero-cigarro.jpg'),
                    logo: require('../css/img/logo-zero-cigarro.png'),
                    url: 'http://zerocigarro.com.br/'
                },
                {
                    nome: 'Victual',
                    descricao: 'Serviço de entrega de refeições personalizadas criadas por nutricionistas',
                    img: require('../css/img/background-victual.jpg'),
                    logo: require('../css/img/logo-victual.png'),
                    url: ''
                }
            ]
        }
    }

    renderList() {
        return this.state.products.map((product: any) => {
            return (
                <div className="myCard container col-sm-12 col-md-6 col-lg-3" style={{ background: `url(${product.logo}) center no-repeat, linear-gradient(0deg, rgba(255,255,255,1), rgba(255, 255, 255,1)), url(${product.img}) center`, backgroundSize: '180px, cover' }} key={product.nome}>
                    <div className="my-card-overlay" onClick={e => {}}>
                        <h1>{product.nome}</h1>
                        <p>{product.descricao}</p>
                        {product.url !== '' ?
                            <a href={product.url} target="_blank">  <button type="button" className="btn btn-light bt-link">Visitar Site </button> </a>
                            :
                            <div />
                        }
                    </div>
                </div>
            );
        })

    }
    render() {
        return (
            <div className="align-items-center portfolio-f-block">
                {this.renderList()}
            </div>
        )
    }
}

export default ProductList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProductItemsComponent.tsx